export default {
    'export': 'Export',
    'export-as-excel': 'Export as excel file',
    'print-the-final-accounts': 'Print final accounts',
    'unlock-accounts': 'Cancel account closure',
    'lock-accounts': 'Close accounts',

    account: {
        operations: 'Operating',
        trade: 'Trading',
        'gains-and-losses': 'Profit and loss',
        budget: 'Balance sheet',
    },

    'unlock-current-financial-file-accounts': 'Cancel closing financial file',
    'are-you-sure-you-want-to-unlock-accounts': 'Do you want to cancel the account closure?',

    'lock-financial-file-accounts': 'Closing financial file accounts',

    'operations-account-balance': 'Operating balance',
    'trade-account-balance': 'Trading balance',
    'gains-and-losses-account-balance': 'Profit and loss balance',
    'budget-account-balance': 'Balance sheet balance',

    'lock': 'Close accounts',
    'next': 'Next',
    'previous': 'Previous',
    'cancel': 'Cancel',
    'lock-dialog': {
        'checking-all-bonds-are-posted': 'All bonds are posted',
        'checking-all-invoices-are-posted': 'All invoices are posted',
        'checking-all-material-journals-are-posted': 'All journals are posted',
        'checking-all-manufacturing-bonds-are-posted': 'All manufacturing bonds are posted',
        'checking-no-negative-values-for-materials': 'No materials with negative balances',

        'radio-select': 'Select',
        'radio-create': 'Create',

        'stepper-validate': 'Verify',
        'stepper-lock-accounts': 'Reset accounts balances',
        'stepper-lock': 'Closing Accounts',

        'the-profit-and-loss-account': 'Revolving profit and loss account',
        'the-materials-end-of-term-account': 'Ending inventory account',
        'it-is-set-in-financial-file-accounts': 'Assigned from settings page',
        
        'account': 'Account',
        'new-account-parent': 'Main account',
        'new-account-name': 'Account name',

        'account-create-note': '*Note: the account will be created as a sub-account and its final account will be the balance sheet',
        
        details: `
        <span class="primary--text" style="font-size: 1rem">After closing this file:</span> <br>
        -   The following accounts will be created as balance accounts: Ending inventory account - Revolving profit and loss account (in case they do not exist).<br>
        -   A closing bond will be created, and will include:<br>
            • Closing entries for all non-balance accounts in a different nature of its balances (credit or debit).<br>
            • Debit entry for the ending inventory account with the amount of inventory that is still on hand at the end of the accounting period.<br>
            • Debit or credit entry for the revolving profit and loss account with the profit and loss balance.<br>
        -   The financial file will be locked for editing, and only the admin can unclose the financial file.<br>
        `
    },

    'sorry-you-can-not-close-the-financial-file-because-of-the-unposted-bonds-with-the-numbers' : 'Sorry, it is not possible to close the financial file due to non-deferred debenture with numbers',

    'rerotate-financial-file': 'Revolve the financial file again?',
    'do-you-want-to-rerotate-financial-file': 'The financial file is already Revolved to the financial file: "{financialFile}". If the previous revolving process is not completed, it will resume or it will re-revolve the financial file. You always can force re-revolving whenever you want. Do you want to continue?',

    'rotate': 'Revolve to new financial file',
    're-rotate': 'Re-revolve',
    'resume': 'Resume',
    'rotate-dialog': {
        'stepper-validate': 'Verify',
        'stepper-financial-file': 'Create financial file',
        'stepper-move-trees': 'Moving accounts and items',
        'stepper-rotate': 'Revolving to new financial file',
        'stepper-rotate-steps': 'Revolving steps',

        'financial-file-is-locked': 'The financial file is closed ... you can continue',
        'financial-file-is-not-locked': 'The financial file is unclosed',

        'rotate-financial-file': 'Move financial file to new one',
        'new-financial-file-name': 'The new financial file name',
        'fiscal-year-name': 'Fiscal year name',
        'start-fiscal-year': 'Fiscal year beginning',
        'end-fiscal-year': 'Fiscal year ending',
        'move-accounts-tree': 'Move accounts',
        
        'first-term-account': {
            text: 'Beginning of inventory account',
            'account-parent': 'Main account',
            'account-name': 'Account name',
            'account-no': 'Account ID',
        },

        'move-materials-trees': 'Move items',
        'same-parent-no': 'The account number is reserved',
        'the-financial-file-is-ready-to-rotate': 'The financial file is ready to revolve ... click "revolve" to confirm',
        
        details: `
        <span class="primary--text" style="font-size: 1rem">After moving this file to a new one:</span><br>
        -   A new financial file will be created with the same default currency.<br>
        -   Access permissions to the new file (will be the same for the old) (admin can edit their permissions).<br>
        -   All accounts and their customized statements will be moved from the previous file to the new one.<br>
        -   An opening bond will be created, which will include the balances of the permanent accounts (balance sheet accounts) and beginning inventory balance, which will be equal to the ending inventory of the previous accounting period. <br>
        -   All warehouses and items will be moved.<br>
        -   Warehouses inventory items will be valued based on:<br>
            • Item's inventory prices (that are assigned from the Items Inventory page), and if there are any items with unspecified prices, the last purchase price will be used.<br>
        -   An opening items journal will be created, which will include the item quantities from the previous accounting period.
        `,

        steps: {
            'create-new-financial-file': 'Create a new financial file',
            'move-accounts-tree': 'Move accounts tree',
            'move-custom-statements': 'Move custom statements',
            'move-item-trees': 'Move item trees',
            'create-opening-accounting-bond': 'Create opening accounting bond',
            'create-opening-items-journal': 'Create opening items journal',
            'init-access-permissions': 'Initializing permissions',
        },
        'in-progress': 'in progress',

        'wait-please': 'It will take a few minutes, thanks for your patience',
    }
}